import { RestTypesType } from '@spa/constants/RestTypes'
import type { DoubleStringTuple } from '@spa/features/Scheduling'
import type { Moment } from 'moment'

import {
  getDateRangeMomentDate,
  type DayFieldsValue
} from '../RestFormSection/components/DayFields/DayFields'
import { getTimeRangeMomentDate } from '../RestFormSection/utils/getTimeRangeMomentDate'

/**
 * Get date range from formData based on restType
 */
export const getMomentDates = ({
  defaultStart,
  selectedRestType,
  timeRange,
  dateRange
}: {
  defaultStart: Moment
  selectedRestType: string
  timeRange: DoubleStringTuple
  dateRange: DayFieldsValue
}) => {
  if (selectedRestType === RestTypesType.DAY) {
    return getDateRangeMomentDate(dateRange)
  }

  return getTimeRangeMomentDate({
    timeRange,
    startsAt: defaultStart
  })
}
